import { createFileRoute } from '@tanstack/react-router';

import { PdfPreviewPage, registerPdfFonts } from '@/features/benchmarking';

registerPdfFonts();

export const Route = createFileRoute('/microdados/pdf-preview')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw new Error('This route is only available in development.');
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    escola: typeof search.escola === 'number' ? search.escola : undefined,
    modelo: typeof search.modelo === 'string' ? search.modelo : undefined,
  }),
  component: function PdfPreviewRoute() {
    const { escola, modelo } = Route.useSearch();
    return (
      <PdfPreviewPage
        escola={escola}
        modelo={modelo}
      />
    );
  },
});
